import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PLATFORM_CONFIG} from '../../config/platform.config';
import {AnyObject} from '../../interfaces/utils';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {IIngredient} from '../../models/ingredient';
import {MiniSphereNamespace} from '../../namespaces/mini-sphere.namespace';
import {fadeInAnimation} from '../../animations/fade-in.animation';

interface IAllergyForm {
  ingredientName: FormControl<string>;
  ingredientId: FormControl<string>;
  allergyDate: FormControl<Date>;
}
@Component({
  selector: 'app-modal-add-allergy',
  templateUrl: './modal-add-allergy.component.html',
  styleUrls: ['./modal-add-allergy.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalAddAllergyComponent implements OnInit {
  @Input() isVisible = false;
  @Input() allergies: MiniSphereNamespace.IIngredient[] = [];
  @Output() close: EventEmitter<MiniSphereNamespace.IIngredient[]> = new EventEmitter<MiniSphereNamespace.IIngredient[]>();

  get getAllergyIds(): string[] {
    return this.allergies.map(({ingredientId}: MiniSphereNamespace.IIngredient) => ingredientId);
  }


  platformConfig: AnyObject = PLATFORM_CONFIG;
  allergyForm: FormGroup<IAllergyForm>;

  constructor() {
  }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.allergyForm = new FormGroup<IAllergyForm>({
      ingredientName: new FormControl<string>('', [Validators.required]),
      ingredientId: new FormControl<string>('', [Validators.required]),
      allergyDate: new FormControl<Date>(null, [Validators.required])
    });
  }

  async onSelectedAllergyIngredient(ingredient: Partial<IIngredient>): Promise<void> {
    if (!this.isVisible) return;

    // entonces el ingrediente se emite al formulario de alergia para validar que se complete el form
    // antes de hacer push
    this.allergyForm.get('ingredientName').setValue(ingredient.name);
    this.allergyForm.get('ingredientId').setValue(ingredient._id);
  }

  async onCloseModalAddRow(close: boolean): Promise<void> {
    if (close) {
      this.allergyForm.reset();
      this.close.emit(this.allergies);
      return;
    }

    if (this.allergyForm.valid) {
      this.close.emit([...(this.allergies ?? []), {...this.allergyForm.value as MiniSphereNamespace.IIngredient}]);
      this.allergyForm.get('ingredientName').markAsUntouched();
      this.allergyForm.get('ingredientName').setValue('');
      this.allergyForm.get('allergyDate').markAsUntouched();
      this.allergyForm.get('allergyDate').setValue(null);
    }
  }
}
